export default __webpack_public_path__ + "static/media/logoGreensock.49c215a1.png";